export default "__VITE_ASSET__DvYb8W6x__"